import { colors, fonts } from 'theme'
import css from 'styled-jsx/css'

export default css`
  .shifts {
    width: 100%;
    min-height: 120px;
    display: flex;
    flex-direction: column;
  }

  .shifts-container {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }


  .shift-option { 
    height: 36px;
    border-radius: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 1.25rem 0.8rem;
    font: ${fonts.medium};
    font-size: 0.875rem;
    background-color: ${colors.disabled};
    color: ${colors.secondary};
  }

  .shift-option:first-child {
    margin-left: 0;
  }
  .shift-option:last-child {
    margin-right: 0;
  }

  .shift-option.available {
    background-color: ${colors.white};
    border: solid 0.125rem ${colors.primary};
    color: ${colors.primary};
    cursor: pointer;
  }

  .shift-option.available.selected {
    background-color: ${colors.primary};
    color: ${colors.white};
  }

  .reference-container {
    display: flex;
    flex-direction: row;
    margin-top: 1rem;
  }

  .reference {
    font-size: 0.75rem;
    color: ${colors.secondary};
    display: flex;
    flex-direction: row;
    margin-right: 2rem;
  }

  .reference-dot {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    margin-right: 0.5rem;
    background-color: ${colors.disabled};
  }

  .reference-dot.enabled {
    background-color: ${colors.white};
    border: solid 0.125rem ${colors.primary};
  }

  .reference-dot.selected {
    background-color: ${colors.primary};
  }
`